import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _GrantBadgeModal_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './grant-badge.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { extractError } from "discourse/lib/ajax-error";
import { grantableBadges, isBadgeGrantable } from "discourse/lib/grant-badge-utils";
import Badge from "discourse/models/badge";
import UserBadge from "discourse/models/user-badge";
import getURL from "discourse-common/lib/get-url";
import I18n from "discourse-i18n";
import TEMPLATE from "./grant-badge.hbs";
import { setComponentTemplate } from "@ember/component";
let GrantBadgeModal = (_class = (_GrantBadgeModal_brand = /*#__PURE__*/new WeakSet(), class GrantBadgeModal extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _GrantBadgeModal_brand);
    _initializerDefineProperty(this, "loading", _descriptor, this);
    _initializerDefineProperty(this, "saving", _descriptor2, this);
    _initializerDefineProperty(this, "selectedBadgeId", _descriptor3, this);
    _initializerDefineProperty(this, "flash", _descriptor4, this);
    _initializerDefineProperty(this, "flashType", _descriptor5, this);
    _initializerDefineProperty(this, "allBadges", _descriptor6, this);
    _initializerDefineProperty(this, "userBadges", _descriptor7, this);
    _initializerDefineProperty(this, "availableBadges", _descriptor8, this);
  }
  get noAvailableBadges() {
    !this.availableBadges.length;
  }
  get post() {
    return this.args.model.selectedPost;
  }
  get buttonDisabled() {
    return this.saving || !isBadgeGrantable(this.selectedBadgeId, this.availableBadges);
  }
  async loadBadges() {
    this.loading = true;
    try {
      this.allBadges = await Badge.findAll();
      this.userBadges = await UserBadge.findByUsername(this.post.username);
      _assertClassBrand(_GrantBadgeModal_brand, this, _updateAvailableBadges).call(this);
    } catch (e) {
      this.flash = extractError(e);
      this.flashType = "error";
    } finally {
      this.loading = false;
    }
  }
  async performGrantBadge() {
    try {
      this.saving = true;
      const username = this.post.username;
      const newBadge = await UserBadge.grant(this.selectedBadgeId, username, getURL(this.post.url));
      this.userBadges.pushObject(newBadge);
      _assertClassBrand(_GrantBadgeModal_brand, this, _updateAvailableBadges).call(this);
      this.selectedBadgeId = null;
      this.flash = I18n.t("badges.successfully_granted", {
        username,
        badge: newBadge.get("badge.name")
      });
      this.flashType = "success";
    } catch (e) {
      this.flash = extractError(e);
      this.flashType = "error";
    } finally {
      this.saving = false;
    }
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "saving", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedBadgeId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "flash", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "flashType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "allBadges", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "userBadges", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "availableBadges", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "loadBadges", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadBadges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "performGrantBadge", [action], Object.getOwnPropertyDescriptor(_class.prototype, "performGrantBadge"), _class.prototype)), _class);
function _updateAvailableBadges() {
  this.availableBadges = grantableBadges(this.allBadges, this.userBadges);
}
export { GrantBadgeModal as default };
setComponentTemplate(TEMPLATE, GrantBadgeModal);